import React from "react";

//interfaces
import { IBasicAddInput } from "../../../interfaces/textInputs/IBasicTextInput";
import BasicButton from "../buttons/BasicButton";



const BasicAddInput = ({id, className, labelText, labelIsHidden, placeholderText, textString, setTextString, maxLength, isDisabled, isReadOnly, buttonContent, onButtonClick}: IBasicAddInput) => {
    const isButtonDisabled = !textString;

    return (
        <div className={`basic-add-input-wrapper ${className ?? ""} `}>
            <label htmlFor={`basic-add-input-${id || ''}`} className={`${labelIsHidden ? "sr-only" : ""} basic-add-input-label`}>
                {labelText}
            </label>
         
            <input
                key={id ? `basic-add-input-${id}`: ''}
                id={`basic-add-input-${id || ''}`}
                className={"basic-add-input"}
                placeholder={placeholderText}
                value={textString}
                onChange={(e) => setTextString(e.target.value)}
                aria-label="Add your Text"
                maxLength={maxLength}
                disabled={isDisabled}
                readOnly={isReadOnly}
            />

            {buttonContent &&
                <BasicButton 
                    isDisabled={isButtonDisabled || isDisabled} 
                    onButtonClick={onButtonClick} 
                    content={buttonContent}
                    ariaLabel={"Add"} 
                    className="add-button"
                />
            }
        </div>
    );
};

export default BasicAddInput